import { Component, OnInit } from '@angular/core'
import { ContactusGateway } from '../gateways/contact-gateway'
import { ContactusDetail } from '../models/contact'
import { Router } from '@angular/router'
import { ActivatedRoute } from '@angular/router'
import { UserDataService } from '../../user-management/gateways/user-data-service'
import { SubscriptionLike as ISubscription } from 'rxjs'

@Component({
    selector: 'My-input',
    templateUrl: `contact.html`,
    styleUrls: ['./contact.scss']
})
export class ContactComponent implements OnInit {
    contactcontent: string
    insCo: number
    private userDataServiceSubscription: ISubscription
    planyear = 0

    constructor(private gateway: ContactusGateway, private router: Router, private route: ActivatedRoute, private userDataService: UserDataService) {}
    ngOnInit() {
        let ParentName: string
        let SectionName: string
        ParentName = 'CONTACT'
        SectionName = 'CONTACT'

        this.route.params.subscribe((params) => {
            this.insCo = params['insCo']
            console.log('insCo from url' + this.insCo)
        })

        this.userDataServiceSubscription = this.userDataService.currentYear.subscribe((planYear) => {
            console.log(planYear)

            if (planYear === undefined || planYear === 0) {
                //ignore if planYear is not identified.
                return
            } else this.planyear = planYear
        })

        this.gateway.GetCotactContent(ParentName, SectionName, this.insCo, this.planyear).subscribe((model: ContactusDetail[]) => {
            if (model !== undefined && model[0].TextContent !== undefined) {
                this.contactcontent = model[0].TextContent
            } else {
                this.contactcontent = ''
            }
        })

        console.log('val contactcontent' + this.contactcontent)

        if (this.contactcontent == undefined) this.contactcontent = ''
    }
}
